import React from 'react';
import { Typography } from '@mui/material';
import { useStyles } from '../styles';

export const MultiMediaListHeaderTitle = ({ title }: { title: string }) => {
  const classes = useStyles();

  return (
    <Typography variant="body2" className={classes.headerText} gutterBottom>
      <span className={classes.multiMediaListHeaderTitle}>{title}</span>
    </Typography>
  );
};
